<script>
	import Carousel from 'svelte-carousel'
	let y;
	let images = ['./static/pic01.jpg', './static/pic02.jpg', './static/pic03.jpg', './static/pic04.jpg', './static/pic05.jpg', './static/pic06.jpg', './static/pic07.jpg', './static/pic08.jpg', './static/pic09.jpg', './static/pic10.jpg'];
	const goTop = function(){
		y=0;
	};
</script>
<svelte:window bind:scrollY={y}/>
<main>
	<Carousel let:loaded let:showPrevPage let:showNextPage>
		<div slot="prev" on:click="{showPrevPage}" on:click="{goTop}" class="custom-arrow custom-arrow-prev">
			<i>
				<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"><path d="M1,5.22V24.78A4.22,4.22,0,0,0,5.22,29H24.78A4.22,4.22,0,0,0,29,24.78V5.22A4.22,4.22,0,0,0,24.78,1H5.22A4.22,4.22,0,0,0,1,5.22Zm7.24,10a1.78,1.78,0,0,1,.51-1.25l5.49-5.49a1.7,1.7,0,0,1,1.2-.5A1.76,1.76,0,0,1,17,8.85a1.72,1.72,0,0,1-.28,2.05L12.5,15.11a.14.14,0,0,0,0,.2l4.34,4.35a1.72,1.72,0,0,1,.32,2,1.7,1.7,0,0,1-1.5.9,1.75,1.75,0,0,1-1.24-.52L8.77,16.42A1.84,1.84,0,0,1,8.24,15.17Z" transform="translate(-1 -1)"/></svg>
			</i>
		</div>
		{#each images as src, imageIndex (src)}
		<div class="img-container">
			{#if loaded.includes(imageIndex)}
			<img {src} alt="nature"/>
			{/if}
		</div>
		{/each}
		<div slot="next" on:click="{showNextPage}" on:click="{goTop}" class="custom-arrow custom-arrow-next">
			<i>
				<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"><path d="M24.78,1H5.22A4.22,4.22,0,0,0,1,5.22V24.78A4.22,4.22,0,0,0,5.22,29H24.78A4.22,4.22,0,0,0,29,24.78V5.22A4.22,4.22,0,0,0,24.78,1ZM21.23,16.42l-5.67,5.66a1.75,1.75,0,0,1-1.24.52,1.7,1.7,0,0,1-1.5-.9,1.72,1.72,0,0,1,.32-2l4.34-4.35a.14.14,0,0,0,0-.2L13.29,10.9A1.72,1.72,0,0,1,13,8.85a1.76,1.76,0,0,1,1.55-.92,1.7,1.7,0,0,1,1.2.5l5.49,5.49a1.78,1.78,0,0,1,.51,1.25A1.84,1.84,0,0,1,21.23,16.42Z" transform="translate(-1 -1)"/></svg>
			</i>
		</div>
	</Carousel>

</main>

<style>
	main {
		text-align: center;
		background-color: #E7DCCD;
		margin: 0 auto;
		min-height: 100vh;
	}
	img {
		width: clamp(50rem, 70vw, 108rem);
	}
	.custom-arrow {
		width:4rem;
		height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: transparent;
	}
	.custom-arrow i {
		cursor: pointer;
		position: fixed;
	}
	.custom-arrow i svg {
		width: 3rem;
		height: 3rem;
		fill: #5F5F5F;
	}
	.custom-arrow i svg:hover {
		fill:#BFA885;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>